import React from 'react';

const SKILLS = ['UX', 'UI', 'Frontend', 'Design Systems', 'Accessibility'];

const Hero = () => {
	return (
		<section className="hero" id="top">
			<div className="hero-inner">
				<div className="hero-block">
					{/* screen readers get the heading in reading order; the visual
					    wordmark interleaves name and ribbons, so it's hidden from them */}
					<h1 className="hero-wordmark">
						<span className="visually-hidden">
							Noora Jumppanen, Design Engineer
						</span>
						<span
							className="hero-name-line hero-name-line--first"
							aria-hidden="true"
						>
							Noora
						</span>
						<span className="hero-ribbon hero-ribbon--yellow" aria-hidden="true">
							<span className="hero-ribbon-fill">Design Engineer</span>
						</span>
						<span
							className="hero-name-line hero-name-line--second"
							aria-hidden="true"
						>
							Jumppanen
						</span>
						<span className="hero-ribbon hero-ribbon--cyan" aria-hidden="true">
							<span className="hero-ribbon-fill">
								{SKILLS.map((skill, i) => (
									<React.Fragment key={skill}>
										{i > 0 && (
											<>
												{' '}
												<span className="ribbon-square"></span>{' '}
											</>
										)}
										{skill}
									</React.Fragment>
								))}
							</span>
						</span>
					</h1>
					<ul className="visually-hidden">
						{SKILLS.map((skill) => (
							<li key={skill}>{skill}</li>
						))}
					</ul>
					{/* each line rises out of its own mask; the full text is in the
					    layout from the first frame, so nothing shifts */}
					<p className="hero-lead">
						<span className="hero-lead-line">
							<span>
								Bridging the gap between{' '}
								<span className="hero-lead-mark hero-lead-mark--design">
									UI/UX design
								</span>
							</span>
						</span>{' '}
						<span className="hero-lead-line">
							<span>
								and{' '}
								<span className="hero-lead-mark hero-lead-mark--engineering">
									software engineering
								</span>{' '}
								to
								ship high-quality
							</span>
						</span>{' '}
						<span className="hero-lead-line">
							<span>
								products{' '}
								<span className="hero-lead-mark hero-lead-mark--production">
									from concept to production
								</span>
								.
							</span>
						</span>
					</p>
				</div>
			</div>
		</section>
	);
};

export default Hero;
